<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
                    <c-form-item type="checkbox" label="文件类型" name="type" :options="fileType"></c-form-item>
                    <c-form-item type="input" label="批次号" name="batch_number"></c-form-item>
                    <c-form-item type="input" label="产品号" name="product_number"></c-form-item>
                    <c-form-item type="input" label="CSA号" name="cas_number"></c-form-item>
                    <c-form-item type="input" label="手机号" name="phone_number"></c-form-item>
                </c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="文件类型"
					width="60"
				>
					<template #default="{data}">
                        <span v-if="data.file_type==1" style="color: #00BD8E">COA证书</span>
                        <span v-if="data.file_type==2" style="color: brown">SDS证书</span>
                        <span v-if="data.file_type==3" style="color: yellowgreen">培训证书</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="批次号"
					name="batch_number"
                    width="100"
                ></c-table-column>
				
				<c-table-column
					label="产品号"
					name="product_number"
                    width="100"
                ></c-table-column>
				
				<c-table-column
					label="CSA号"
					name="cas_number"
                    width="100"
				></c-table-column>
				
				<c-table-column
					label="手机号"
					name="phone_number"
                    width="100"
                ></c-table-column>

				<c-table-column
					label="文件地址"
					name="file_url"
                    width="300"
				></c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_file',
		
		data() {
			return {
                fileType: [{
                    name: 'COA证书',
                    value: 1
                }, {
                    name: 'SDS证书',
                    value: 2
                }, {
                    name: '培训证书',
                    value: 3
                }],
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/file/list',
					data
				});
			}
		}
	}
</script>